module.exports = __webpack_public_path__ + "static/media/arrow-forward.5b29c921.svg";